import { margin } from "@mui/system"
import Styles from "./Mobile.module.css"
import { Button, Grid2, Typography } from "@mui/material"
import en from "../../../i18n/English/Api/price.json";
import hi from "../../../i18n/Hindi/Api/price.json";
import kn from "../../../i18n/Kannada/Api/price.json";
import ma from "../../../i18n/Marathi/Api/price.json";
import gu from "../../../i18n/Gujarati/Api/price.json";
import { useLanguage } from "../../../Context/LangContext";
export default function Moblie() {
    const { language } = useLanguage();
    const translations = { en, hi, kn, ma, gu };
    const t = translations[language];
    return (
        <>
            <Grid2 className={Styles.OuterCard}>

                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <h1 className={Styles.heading} style={{ fontWeight: 600 }}>
                        {t.heading}
                    </h1>
                </div>
                <Typography className={Styles.subTitle}>
                    {t.subTitle}
                </Typography>



                    <Grid2 className={Styles.subCard}>

                        <Grid2 className={Styles.card}>
                            <Typography className={Styles.planTitle}>
                            {t.plans[0].title}
                            </Typography>
                            <Button className={Styles.button}>
                            {t.plans[0].buttonText}
                            </Button>
                        </Grid2>

                        <Typography className={Styles.amt}>
                        <span className={Styles.span}>₹999</span>{t.plans[0].price}
                        </Typography>

                        <Typography className={Styles.planTxt}>
                        {t.plans[0].description}
                        </Typography>
                    </Grid2>

                    <Grid2 className={Styles.subCard} >

                        <Grid2 className={Styles.card}>
                            <Typography className={Styles.planTitle}>
                            {t.plans[1].title}
                            </Typography>
                            <Button className={Styles.button}>
                            {t.plans[1].buttonText}
                            </Button>
                        </Grid2>

                        <Typography className={Styles.amt}>
                        <span className={Styles.span}>₹9,999</span>{t.plans[1].price}
                        </Typography>


                        <Typography className={Styles.planTxt}>
                        {t.plans[1].description}
                        </Typography>
                    </Grid2>


                <h2 className={Styles.disclaimer}>
                    {t.disclaimerTitle}
                </h2>

                <Typography className={Styles.txt}>
                    {t.disclaimerText}
                </Typography>

            </Grid2>
        </>
    )
}